module.exports = __webpack_public_path__ + "static/media/boss-bar-red-08.24f42725.png";